export default "__VITE_ASSET__0Wj53oNi__"